import { Injectable, HostListener, Inject, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AuthenticationService } from 'src/app/components/services/auth/authentication.service';
import { WINDOW } from "./windows.service";
// Menu
export interface Menu {
	path?: string;
	title?: string;
	icon?: string;
	type?: string;
	badgeType?: string;
	badgeValue?: string;
	active?: boolean;
	bookmark?: boolean;
	isAdmin?: boolean;
	isBusiness?: boolean;
	children?: Menu[];
}

@Injectable({
	providedIn: 'root'
})

export class NavService implements OnInit {

	public screenWidth: any
	public collapseSidebar: boolean = false

	constructor(@Inject(WINDOW) private window,
	private authService: AuthenticationService
	) {
		this.onResize();
		if (this.screenWidth < 991) {
			this.collapseSidebar = true
		}
	}
	
	ngOnInit() {
		
	}
	// Windows width
	@HostListener("window:resize", ['$event'])
	onResize(event?) {
		this.screenWidth = window.innerWidth;
		
	}
	MENUITEMS: Menu[] =[
		{
			title: 'Inicio', path: '/inicio', icon: 'home', type: 'link', badgeType: 'primary', active: false
		},
		{
			title: 'Dashboard', path: '/dashboard', icon: 'grid', type: 'link', badgeType: 'primary', active: false
		},
		{
			title: 'Usuarios', path: '/users', icon: 'user-plus', type: 'link', badgeType: 'primary', active: false
		},
		/*{
			title: 'Maquinaria', icon: 'box', type: 'sub', active: false, children: [
				{ path: '/products/product-list', title: 'Lista Máquinas', type: 'link' },
				{ path: '/products/add-product', title: 'Agregar Maquinaria', type: 'link' },
				{ path: '/products/catalogs', title: 'Catálogos', type: 'link' },
				//{ path: '/products/sub-category', title: 'Sub Categorias', type: 'link' },
			]
		},
		{
			title: 'Refacciones', icon: 'tool', type: 'sub', active: false, children: [
				{ path: '/products/parts-list', title: 'Lista Refacciones', type: 'link' },
				{ path: '/products/parts/add-product', title: 'Agregar Refacción', type: 'link' },
			]
		},
		{
			title: 'Servicios', icon: 'clipboard', type: 'sub', active: false, children: [
				{ path: '/sales/services', title: 'Lista Servicios', type: 'link' },
				{ path: '/sales/services/add-service', title: 'Agregar Servicio', type: 'link' },
			]
		},
		{
			title: 'Souvenirs', icon: 'gift', type: 'sub', active: false, children: [
				{ path: '/products/souvenirs', title: 'Lista Souvenirs', type: 'link' },
				{ path: '/products/souvenirs/add-souvenir', title: 'Agregar Souvenir', type: 'link' },
			]
		},*/
		/*{
			title: 'Clientes', path: '/clients',  icon: 'user-check', type: 'link', badgeType: 'primary', active: false
		},
		{
			title: 'Cotizaciones', path: '/sales/quotations',  icon: 'check-square', type: 'link', badgeType: 'primary', active: false
		},
		{
			title: 'Pedidos', path: '/sales/orders', icon: 'shopping-cart', type: 'link', badgeType: 'primary', active: false
		},
		{
			title: 'Pagos', path: '/sales/transactions', icon: 'dollar-sign', type: 'link', active: false
		},*/
		/*{
			title: 'Cupones', icon: 'tag', type: 'sub', active: false, children: [
				{ path: '/coupons/list-coupons', title: 'Lista Cupones', type: 'link' },
				{ path: '/coupons/create-coupons', title: 'Crear Cupón', type: 'link' },
			]
		},*/
		/*{
			title: 'Páginas', icon: 'clipboard', type: 'sub', active: false, children: [
				{ path: '/pages/list-page', title: 'Lista Páginas', type: 'link' },
				{ path: '/pages/create-page', title: 'Crear Página', type: 'link' },
			]
		},
		{
			title: 'Menús', icon: 'align-left', type: 'sub', active: false, children: [
				{ path: '/menus/list-menu', title: 'Lista de Menú', type: 'link' },
				{ path: '/menus/create-menu', title: 'Crear Menú', type: 'link' },
			]
		},*/
		/*{
			title: 'Media', path: '/media', icon: 'camera', type: 'link', active: false
		},*/
		// {
		// 	title: 'Registro estatal', path: '/users/business', icon: 'map-pin', type: 'link', badgeType: 'primary', active: false
		// },
		{
			title: 'Reportes', icon: 'map-pin', type: 'sub', children: [
				{path: '/reportes/nuevo', title: 'Nuevo reporte', type: 'link'},
				{path: '/reports', title: 'Turnados', type: 'link'},
				{path: '/reports/not-assigned', title: 'Sin turnar', type: 'link'},
				{path: '/reports/mapa', title: 'Mapa', type: 'link'},
				{path: '/reports/calidad-agua', title: 'Calidad de agua', type: 'link'}
			]
		},
		{
			// title: 'Reportes', path: '/reports', icon: 'bar-chart-2', type: 'link', badgeType: 'primary', active: false
			title: 'Estadísticas', icon: 'bar-chart-2', type: 'sub', children: [
				{path: '/reports/general', title: 'General', type: 'link'},
				{path: '/reports/area', title: 'Por área', type: 'link'},
				{path: '/reports/fuente', title: 'Por fuente', type: 'link'},
				{path: '/reports/ciudadano', title: 'Por ciudadano', type: 'link'},
				{path: '/reports/colonia', title: 'Por colonia', type: 'link'}
			]
		},
		// {
		// 	title: 'Trámites y servicios', icon: 'list', type: 'sub', active: false, children: [
		// 		{ path: '/catalogs/bandeja', title: 'Bandeja', type: 'link' },
		// 		{ path: '/catalogs/consulta-catalogo', title: 'Catálogo', type: 'link' },
		// 	]
		// },
		{
			title: 'Trámites', icon: 'file-text', type: 'sub', active: false, children: [
				{ path: '/tramites-admin/configuracion', title: 'Configuración', type: 'link' },
				{ path: '/tramites-admin/catalogo',      title: 'Catálogo',      type: 'link' },
				{ path: '/tramites-admin/solicitudes',   title: 'Solicitudes',   type: 'link' },
			]
		},
		{
			title: 'Bolsa de trabajo', icon: 'briefcase', type: 'sub', active: false, children: [
				{ path: '/jobs/companies', title: 'Empresas', type: 'link' },
				{ path: '/jobs', title: 'Vacantes', type: 'link' },
			]
		},
		{
			title: 'Limpia Pública', icon: 'trash-2', type: 'sub', active: false, children: [
			{ path: '/limpia-publica/dashboard', title: 'Dashboard', type: 'link' },
			{ path: '/limpia-publica/monitor', title: 'Monitoreo', type: 'link' },
			{ path: '/limpia-publica/suscripciones', title: 'Suscripciones', type: 'link' },
			{ path: '/limpia-publica/programacion', title: 'Programación', type: 'link' },
			{ path: '/limpia-publica/bitacora', title: 'Bitácora', type: 'link' },
			{ path: '/limpia-publica/notificaciones', title: 'Notificaciones', type: 'link' },
			{ path: '/limpia-publica/configuracion', title: 'Configuración', type: 'link' },
			]
		},
		// { title: 'Catastro', icon: 'home', type: 'sub', active: false, children: [
		// 	{ path: '/catastro/predios', title: 'Predios', type: 'link' },
		// 	{ path: '/catastro/pagos', title: 'Pagos', type: 'link' },
		// ] },
		// { title: 'Tránsito', icon: 'truck', type: 'sub', active: false, children: [
		// 	{ path: '/transito/multas', title: 'Catálogo de Multas', type: 'link' },
		// 	{ path: '/transito/infracciones', title: 'Infracciones', type: 'link' },
		// ] },
		{
			title: 'Formularios', icon: 'file-plus', type: 'sub', active: false, children: [
				{ path: '/formularios/lista',      title: 'Lista de Encuestas', type: 'link' },
			]
		},
		{
			title: 'Catálogos', icon: 'list', type: 'sub', active: false, children: [
			{ path: '/catalogs/dependencias', title: 'Dependencias', type: 'link' },
			{ path: '/catalogs/tipos-documento', title: 'Tipos de documento', type: 'link' },
			{ path: '/catalogs/codigos-scian', title: 'Códigos SCIAN', type: 'link' },
			{ path: '/catalogs/reportes', title: 'Reportes', type: 'link' },
			{ path: '/catalogs/turnos', title: 'Turnos', type: 'link' },
			]
		},
		{
			title: 'Seguridad', icon: 'shield', type: 'sub', active: false, children: [
				{ path: '/seguridad/areas',    title: 'Áreas',    type: 'link' },
				{ path: '/seguridad/perfiles', title: 'Perfiles', type: 'link' },
				{ path: '/seguridad/modulos',  title: 'Módulos',  type: 'link' },
			]
		},
		{
			title: 'Sistema', icon: 'settings', type: 'sub', active: false, children: [
				{ path: '/sistema/variables', title: 'Variables de Sistema', type: 'link' },
				{ path: '/sistema/integraciones-pago', title: 'Integraciones de Pago', type: 'link' },
				{ path: '/sistema/configuracion', title: 'Configuración', type: 'link' },
			]
		},
		/*{
			title: 'Viajes', path: '/trips', icon: 'navigation-2', type: 'link', badgeType: 'primary', active: false
		}*/	
		// {
		// 	title: 'Encuestas', path: '/surveys', icon: 'clipboard', type: 'link', badgeType: 'primary', active: false
		// },
		// {
		// 	title: 'Ocupación hotelera', path: '/surveys/occupation', icon: 'server', type: 'link', badgeType: 'primary', active: false
		// },
		// {
		// 	title: 'Reportes', path: '/reports', icon: 'bar-chart-2', type: 'link', active: false
		// },
		// {
		// 	title: 'Usuarios', icon: 'user-plus', type: 'sub', active: false, children: [
		// 		{ path: '/users', title: 'Negocios', type: 'link' },
		// 		{ path: '/users/admins', title: 'Administradores', type: 'link' },
		// 	]
		// },
		/*{
			title: 'Proveedores', icon: 'users', type: 'sub', active: false, children: [
				{ path: '/vendors/list-vendors', title: 'Lista Proveedores', type: 'link' },
				{ path: '/vendors/create-vendors', title: 'Crear Proveedor', type: 'link' },
			]
		},*/
		/*{
			title: 'Localización', icon: 'chrome', type: 'sub', children: [
				{ path: '/localization/translations', title: 'Traducciones', type: 'link' },
				{ path: '/localization/currency-rates', title: 'Tipo de Cambio', type: 'link' },
				{ path: '/localization/taxes', title: 'Impuestos', type: 'link' },
			]
		},*/
		/*{
			title: 'Reportes', path: '/reports', icon: 'bar-chart', type: 'link', active: false
		},
		{
			title: 'Facturas', path: '/invoice', icon: 'archive', type: 'link', active: false
		},
		{
			title: 'Ajustes', icon: 'settings', type: 'sub', children: [
				{ path: '/settings/profile', title: 'Perfil', type: 'link' },
			]
		},
		{
			title: 'Iniciar sesión',path: '/admin', icon: 'log-in', type: 'link', active: false
		}*/
	]
	// Array
	items = new BehaviorSubject<Menu[]>(this.MENUITEMS);

	/*Menú User*/
	MENUITEMSUSER: Menu[] =[
		{
			title: 'Inicio', path: '/menus', icon: 'menu', type: 'link', badgeType: 'primary', active: false
		},
		{
			title: 'Mis reportes', path: '/reports/my-user-reports', icon: 'monitor', type: 'link', badgeType: 'primary', active: false
		},
		// {
		// 	title: 'Agregar reporte', path: '/reports/my-user-reports/create-report', icon: 'clipboard', type: 'link', badgeType: 'primary', active: false
		// },
		// {
		// 	title: 'Mis viajes', path: '/trips/my-trips', icon: 'map', type: 'link', badgeType: 'primary', active: false
		// },
	]
	itemsUser = new BehaviorSubject<Menu[]>(this.MENUITEMSUSER);


	/*Menu Área*/
	MENUAREA: Menu[] =[
		{
			title: 'Dashboard', path: '/dashboard', icon: 'home', type: 'link', badgeType: 'primary', active: false
		},
		{
			title: 'Mis reportes', path: '/reports/my-area-reports', icon: 'monitor', type: 'link', badgeType: 'primary', active: false
		},
		// {
		// 	title: 'Ordenes de trabajo', path: '/work-orders', icon: 'clipboard', type: 'link', badgeType: 'primary', active: false
		// },
	]
	itemsArea = new BehaviorSubject<Menu[]>(this.MENUAREA);

	/*Menu Supervisor*/
	MENUSUPERVISOR: Menu[] =[
		{
			title: 'Dashboard', path: '/dashboard', icon: 'home', type: 'link', badgeType: 'primary', active: false
		},
		/*{
			title: 'Reportes', icon: 'map-pin', type: 'sub', children: [
				{path: '/reports', title: 'Turnados', type: 'link'},
				{path: '/reports/not-assigned', title: 'Sin turnar', type: 'link'}
			]
		},*/
		/*{
			title: 'Estadísticas', icon: 'bar-chart-2', type: 'sub', children: [
				{path: '/reports/general', title: 'General', type: 'link'},
				{path: '/reports/area', title: 'Por área', type: 'link'},
				{path: '/reports/fuente', title: 'Por fuente', type: 'link'},
				{path: '/reports/ciudadano', title: 'Por ciudadano', type: 'link'},
				{path: '/reports/colonia', title: 'Por colonia', type: 'link'}
			]
		},*/
	]
	itemsSupervisor = new BehaviorSubject<Menu[]>(this.MENUSUPERVISOR);

	/*Menú SuperAdmin*/
	MENUSUPERADMIN: Menu[] =[
		{
			title: 'Dashboard', path: '/dashboard', icon: 'home', type: 'link', badgeType: 'primary', active: false
		},
		/*{
			title: 'Reportes', icon: 'map-pin', type: 'sub', children: [
				{path: '/reports', title: 'Turnados', type: 'link'},
				{path: '/reports/not-assigned', title: 'Sin turnar', type: 'link'}
			]
		},*/
		/*{
			title: 'Estadísticas', icon: 'bar-chart-2', type: 'sub', children: [
				{path: '/reports/general', title: 'General', type: 'link'},
				{path: '/reports/area', title: 'Por área', type: 'link'},
				{path: '/reports/fuente', title: 'Por fuente', type: 'link'},
				{path: '/reports/ciudadano', title: 'Por ciudadano', type: 'link'},
				{path: '/reports/colonia', title: 'Por colonia', type: 'link'}
			]
		},*/
		{
			title: 'Usuarios', icon: 'user-plus', type: 'sub', active: false, children: [
				{ path: '/users', title: 'Ciudadanos', type: 'link' },
				{ path: '/users/neighborhood', title: 'Jefes de manzana', type: 'link' },
				{ path: '/users/officers', title: 'Enlace', type: 'link' },
				{ path: '/users/supervisors', title: 'Supervisores', type: 'link' },
				{ path: '/users/admins', title: 'Administradores', type: 'link' },
			]
		},
		{
			title: 'Catálogos', icon: 'list', type: 'sub', active: false, children: [
				{ path: '/catalogs/areas', title: 'Áreas', type: 'link' },
				// { path: '/catalogs/services', title: 'Servicios', type: 'link' },
				// { path: '/catalogs/formalities', title: 'Trámites', type: 'link'},
				// { path: '/catalogs/sources', title: 'Fuentes', type: 'link' },
				// { path: '/catalogs/users', title: 'Perfiles', type: 'link' },
				{ path: '/catalogs/reportes', title: 'Reportes', type: 'link' },
			]
		},
		/*{
			title: 'Viajes', path: '/trips', icon: 'navigation-2', type: 'link', badgeType: 'primary', active: false
		}*/		
	]
	itemsSuperAdmin = new BehaviorSubject<Menu[]>(this.MENUSUPERADMIN);

	/**
	 * Mapa estático: permissionKey → ítem de menú (path + estructura)
	 * Permite filtrar MENUITEMS por permisos sin reescribir toda la estructura.
	 * Los menús sub (type: 'sub') se incluyen si al menos un hijo es visible.
	 */
	private PERMISSION_KEY_MAP: { key: string; path?: string }[] = [
		{ key: 'dashboard',                 path: '/dashboard'                   },
		{ key: 'ciudadanos',                path: '/users'                        },
		{ key: 'reportes',                                                         },
		{ key: 'reportes.nuevo',            path: '/reportes/nuevo'               },
		{ key: 'reportes.turnados',         path: '/reports'                      },
		{ key: 'reportes.sin_turnar',       path: '/reports/not-assigned'        },
		{ key: 'reportes.mapa',             path: '/reports/mapa'                 },
		{ key: 'reportes.calidad_agua',     path: '/reports/calidad-agua'         },
		{ key: 'estadisticas',                                                     },
		{ key: 'estadisticas.general',      path: '/reports/general'              },
		{ key: 'estadisticas.area',         path: '/reports/area'                 },
		{ key: 'estadisticas.fuente',       path: '/reports/fuente'               },
		{ key: 'estadisticas.ciudadano',    path: '/reports/ciudadano'            },
		{ key: 'estadisticas.colonia',      path: '/reports/colonia'              },
		{ key: 'tramites',                                                         },
		{ key: 'tramites.configuracion',    path: '/tramites-admin/configuracion'   },
		{ key: 'tramites.catalogo',       path: '/tramites-admin/catalogo'      },
		{ key: 'tramites.solicitudes',    path: '/tramites-admin/solicitudes'   },
		{ key: 'bolsatrabajo',                                                     },
		{ key: 'bolsatrabajo.empresas',     path: '/jobs/companies'               },
		{ key: 'bolsatrabajo.vacantes',     path: '/jobs'                         },
		{ key: 'limpiapublica',                                                    },
	{ key: 'limpiapublica.dashboard',      path: '/limpia-publica/dashboard'      },
	{ key: 'limpiapublica.monitoreo',      path: '/limpia-publica/monitor'        },
	{ key: 'limpiapublica.unidades',       path: '/limpia-publica/unidades'       },
	{ key: 'limpiapublica.rutas',          path: '/limpia-publica/rutas'          },
	{ key: 'limpiapublica.turnos',         path: '/limpia-publica/turnos'         },
	{ key: 'limpiapublica.suscripciones',  path: '/limpia-publica/suscripciones'  },
	{ key: 'limpiapublica.programacion',   path: '/limpia-publica/programacion'   },
	{ key: 'limpiapublica.bitacora',       path: '/limpia-publica/bitacora'       },
	{ key: 'limpiapublica.notificaciones', path: '/limpia-publica/notificaciones' },
	// limpiapublica.configuracion no está en el mapa → siempre visible (hasAccess devuelve true)
		{ key: 'catalogos',                                                        },
	{ key: 'catalogos.dependencias',    path: '/catalogs/dependencias'        },
	{ key: 'catalogos.tiposdoc',        path: '/catalogs/tipos-documento'     },
	{ key: 'catalogos.scian',           path: '/catalogs/codigos-scian'       },
	{ key: 'catalogos.reportes',        path: '/catalogs/reportes'            },
		{ key: 'catalogos.turnos',          path: '/catalogs/turnos'              },
		{ key: 'formularios',                                                      },
		{ key: 'formularios.lista',       path: '/formularios/lista'             },
		{ key: 'seguridad',                                                        },
		{ key: 'seguridad.areas',           path: '/seguridad/areas'              },
		{ key: 'seguridad.perfiles',        path: '/seguridad/perfiles'           },
		{ key: 'seguridad.modulos',         path: '/seguridad/modulos'            },
		{ key: 'seguridad.usuarios',        path: '/seguridad/usuarios'           },
		{ key: 'sistema',                                                          },
		{ key: 'sistema.variables',         path: '/sistema/variables'            },
		{ key: 'sistema.integraciones',     path: '/sistema/integraciones-pago'   },
		{ key: 'sistema.configuracion',     path: '/sistema/configuracion'        },
	];

	/**
	 * Filtra el árbol de menú estático dejando solo los ítems que el usuario
	 * tiene permiso de ver (can_view === true).
	 * Si no hay permisos definidos, devuelve el menú completo (compatibilidad).
	 */
	public buildMenuFromPermissions(
		baseMenu: Menu[],
		permissionsMap: Record<string, any>
	): Menu[] {
		if (!permissionsMap || Object.keys(permissionsMap).length === 0) {
			return baseMenu;
		}

		const hasAccess = (path: string): boolean => {
			const entry = this.PERMISSION_KEY_MAP.find(e => e.path === path);
			if (!entry) return true; // ítems sin mapa = siempre visibles
			return permissionsMap[entry.key]?.can_view === true;
		};

		const filtered: Menu[] = [];
		for (const item of baseMenu) {
			if (item.children && item.children.length > 0) {
				const visibleChildren = item.children.filter(c => hasAccess(c.path));
				if (visibleChildren.length > 0) {
					filtered.push({ ...item, children: visibleChildren });
				}
			} else {
				if (hasAccess(item.path)) {
					filtered.push(item);
				}
			}
		}
		return filtered;
	}

	/** Actualiza el BehaviorSubject items con el menú filtrado por permisos */
	public refreshMenu(permissionsMap: Record<string, any>): void {
		const filtered = this.buildMenuFromPermissions(this.MENUITEMS, permissionsMap);
		this.items.next(filtered);
	}
}
